import { render, staticRenderFns } from "./GetUs.vue?vue&type=template&id=8507e31a&scoped=true&"
import script from "./GetUs.vue?vue&type=script&lang=js&"
export * from "./GetUs.vue?vue&type=script&lang=js&"
import style0 from "./GetUs.vue?vue&type=style&index=0&id=8507e31a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8507e31a",
  null
  
)

export default component.exports